


































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { MessageCreateViewModel } from '@/models/telephony/message';
import VueUploadComponent from 'vue-upload-component';
import { FileHelper } from '@/helper/file.helper';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import {
  MetadataType,
  ConversationTypes,
  MetadataKeyIdentifier,
} from '@/enums/enums';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getExistingMessageHeaders } from '@/views/account/message/message';
import {
  appointmentService,
  messageService,
  templateService,
  customerService,
} from '@/shared';
import { FileSize } from '@/helper/enum';
import { Attachment, VueDropDown } from '@/models/accounting/customerinfo';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    isValidate() {
      return this.messageToSend.to && this.messageToSend.body;
    },
  },
  components: {
    FileUpload: VueUploadComponent,
    MessageGrid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
  watch: {
    isValidate() {
      if (this.messageToSend.body === '') {
        this.$refs.form.resetValidation();
      }
    },
  },
})

class SendAppointmentMessage extends Base {
  public existingMessageHeaders: VHeaders[] = getExistingMessageHeaders(this);

  public pagedMessages: any[] = [];
  public paginationAppointmentMessages = new PaginationModel('createdAt', true);

  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number = 0;

  public loading: boolean = true;
  public selectedTemplate: string = '';
  public selectedCustomerNumber: string = '';
  public showAttachmentDialog: boolean = false;
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = '';
  public dragging: boolean = false;
  public sendMessageLoader: boolean = false;

  public attachments: Attachment[] = [];
  public customerNumberItems: VueDropDown[] = [];
  public templateItems: any[] = [];
  public customerInfo: any;
  public disableSendButton: boolean = false;

  public constants: any = {
    customerKey: '',
    recordKey: '',
    appointmentDateTime: '',
    vin: '',
    serviceId: ''
  };

  public fileName: string = '';
  public hasFile: boolean = false;
  public appointmentDateTimeMoment: string = '';
  public appointmentDateTime: string = '';
  public appointmentStatus: string = '';
  public serviceWriterId: string = '';
  public selectedAppointmentStatus: string = '';
  public showAppointmentStatusUpdatePopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'sendAppointmentMessage.appointmentStatusUpdateDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      disable: false,
      text: this.$parent.$t(
        'sendAppointmentMessage.appointmentStatusUpdateDialog.btnSubmit'
      ) as string,
    },
    onAction: (): void => {
      this.updateAppointmentStatus();
    },
  };

  public appointmentMessagesActions: any[] = [];

  public headers: VHeaders[] = [
    { text: 'From', value: 'from' },
    { text: 'To', value: 'to' },
    { text: 'Body', value: 'body' },
    { text: 'Action', isNotDataProp: true, sortable: false },
  ];

  // tslint:disable-next-line:max-line-length
  public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );

  public isTemplateLoading: boolean = false;
  public isMessageToSendLoading: boolean = false;
  public isMessageDescriptionLoading: boolean = false;

  constructor() {
    super();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    } else if (methodName === 'sendMessage') {
      if (this.messageToSend.to && this.messageToSend.body) {
        this.sendMessage();
      } else {
        this.showAlert(
          false,
          this.$t('sendAppointmentMessage.messageToAndBodyIsRequired')
        );
      }
    } else if (methodName === 'confirmed') {
      this.showConfirmationPopup('confirmed');
    } else if (methodName === 'declined') {
      this.showConfirmationPopup('declined');
    }

    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('sendAppointmentMessage.btnBackToListTitle'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('sendAppointmentMessage.btnBackToList'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'appointments');

    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.messageToSend.recordIdentifier = this.$route.params.type;
    // SHOULD BIND CUSTOMER KEY, RECORD KEY AND OTHER PROPS
    Object.keys(this.constants).forEach((key) => {
      if (this.$route.query[key]) {
        this.constants[key] = (this.$route.query[key] || '').toString().trim();
      }
    });

    this.messageToSend.recordKey = this.constants.recordKey;
    this.messageToSend.vin = this.constants.vin;
    this.messageToSend.appointmentDateTime = this.constants.appointmentDateTime;

    this.appointmentDateTimeMoment = this.$moment(
      this.constants.appointmentDateTime
    ).format(
      this.$parent.$t(
        'sendAppointmentMessage.appointmentDateTimeMoment'
      ) as string
    );
    switch (this.messageToSend.recordIdentifier) {
      case MetadataType[MetadataType.Deal]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.DealNumber];
        break;
      case MetadataType[MetadataType.Appointment]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.AppointmentNumber];
        break;
      case MetadataType[MetadataType.AR]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.CustomerNumber];
        break;
      case MetadataType[MetadataType.RO]:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber];
        break;
      default:
        this.messageToSend.recordKeyIdentifier =
          MetadataKeyIdentifier[MetadataKeyIdentifier.Unknown];
        break;
    }

    this.getTemplates();
    if (this.constants.customerKey) {
      this.getCustomerInfo();
    }
  }

  public async getTemplates(): Promise<void> {
    try {
      this.isTemplateLoading = true;
      const templates = await templateService.getStoreTemplates('');
      this.templateItems = templates.results;
    } finally {
      this.isTemplateLoading = false;
    }
  }

  public async getCustomerInfo(): Promise<void> {
    if (
      this.constants.customerKey == null ||
      this.constants.customerKey === ''
    ) {
      return;
    }

    try {
      this.isMessageToSendLoading = true;
      const customerInfo = await customerService.getCustomerInfoAsync(
        this.constants.customerKey
      );
      this.customerInfo = customerInfo;
      this.customerNumberItems = this.customerInfo.phoneNumberSelectList;

      this.messageToSend.customerName = this.customerInfo.customerName;
      this.messageToSend.customerKey = this.customerInfo.customerKey;

      if (this.customerNumberItems.length === 1) {
        this.messageToSend.to = this.customerNumberItems[0].value;
      }

      this.getAppointmentDetails();
    } catch (e) {
      this.showAlert(
        false,
        this.$t('sendAppointmentMessage.alertCustomerNotFound')
      );
    } finally {
      this.isMessageToSendLoading = false;
    }
  }

  public async getAppointmentDetails(): Promise<void> {
    try {
      this.loading = true;
      // tslint:disable-next-line:max-line-length
      const response = await messageService.getExistingMessages(
        this.messageToSend.customerKey,
        this.messageToSend.recordKey,
        this.messageToSend.recordIdentifier
      );
      this.appointmentStatus = response.appointmentStatus;
      this.pagedMessages = response.existingMessages.results;
      this.paginationAppointmentMessages.totalItems =
        response.existingMessages.total;
    } finally {
      this.loading = false;
      this.updateToolBar();
    }
  }

  public async getTemplateDescription(selectedTemplateId): Promise<void> {
    if (selectedTemplateId == null || selectedTemplateId === '') {
      this.showAlert(
        false,
        this.$t('sendAppointmentMessage.alertInvalidTemplate')
      );
      return;
    }
    try {
      this.isMessageDescriptionLoading = true;
      // tslint:disable-next-line:max-line-length
      const template = await templateService.getTemplateDescription(
        selectedTemplateId,
        this.messageToSend.customerName,
        this.messageToSend.vin,
        this.appointmentDateTimeMoment,
        this.messageToSend.recordKey,
        '',
        this.constants.serviceId
      );
      this.messageToSend.body = template.text;
    } finally {
      this.isMessageDescriptionLoading = false;
    }
  }

  public openAttachmentDialog(id: string): void {
    this.showAttachmentDialog = true;
  }

  public async updateAppointmentStatus(): Promise<void> {
    try {
      this.showAppointmentStatusUpdatePopup.action.disable = true;
      await appointmentService.updateAppointmentStatus(
        this.constants.recordKey,
        this.selectedAppointmentStatus
      );
      this.showAlert(
        true,
        this.$t('sendAppointmentMessage.alertAppointmentUpdated')
      );
      this.appointmentStatus = this.selectedAppointmentStatus.toUpperCase();
      this.showAppointmentStatusUpdatePopup.model = false;
      this.getAppointmentDetails();
    } finally {
      this.showAppointmentStatusUpdatePopup.action.disable = true;
    }
  }

  public showConfirmationPopup(status) {
    this.selectedAppointmentStatus = status;
    this.showAppointmentStatusUpdatePopup.model = true;
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({
      name: 'app.appointments',
      // params: {
      //   tenantId: this.tenantId.toString(),
      //   enterpriseId: this.enterpriseId.toString(),
      //   storeId: this.storeId.toString(),
      // },
      // query:{
      //   appointmentDateTime: this.constants.appointmentDateTime
      // }
    });
    }
  }

  public async sendMessage(): Promise<boolean> {
    if(this.validateForm()){
      this.messageToSend.files = [];
      if (
        this.messageToSend.to == null ||
        this.messageToSend.to === '' ||
        !this.messageToSend.body
      ) {
        this.showAlert(
          false,
          this.$t('sendAppointmentMessage.alertCustomerNumberFieldEmptyRequired')
        );
        return;
      }
      try {
        this.disableSendButton = true;
        this.sendMessageLoader = true;
        this.$emit('update:progress', this.disableSendButton);
        await messageService.sendMessage(this.messageToSend);
        this.messageToSend.body = '';
        this.showAlert(
          true,
          this.$t('sendAppointmentMessage.alertMessageSentSuccessfully')
        );
        this.messageToSend.files = [];
        this.selectedFiles = '';
        this.getAppointmentDetails();
      } finally {
        this.disableSendButton = false;
        this.sendMessageLoader = false;
        this.$emit('update:progress', this.disableSendButton);
      }
    }
    this.$validator.reset();
  }

  public getFileBytes(callback) {
    if (!this.files || this.files.length <= 0) {
      callback('');
      return;
    }
    for (let i = 0; i < this.files.length; i++) {
      if (!this.files[i]) {
        continue;
      }
      if (!this.files[i].file) {
        continue;
      }

      if (this.files.length === i + 1) {
        const extension = this.files[i].file.name.substring(
          this.files[i].file.name.lastIndexOf('.')
        );
        // tslint:disable-next-line:max-line-length
        const fileBytes = FileHelper.getAttachments(
          this.files[i].file,
          extension,
          this.messageToSend.files,
          callback
        );
      } else {
        const extension = this.files[i].file.name.substring(
          this.files[i].file.name.lastIndexOf('.')
        );
        // tslint:disable-next-line:max-line-length
        const fileBytes = FileHelper.getAttachments(
          this.files[i].file,
          extension,
          this.messageToSend.files,
          null
        );
      }
    }
  }

  public selectFile() {
    const element = this.$refs.upload['$el'].querySelector('input');
    element.click();
  }

  public onChange(fileList) {
    this.selectedFiles = [];
    if (fileList.length > 0) {
      fileList.forEach((file) => {
        const size = file.size / 1024;
        if (size > FileSize.MaxFileSize) {
          this.showAlert(false, this.$t('FileSize.MaxFileSize'));
          return;
        }
        if (file.file) {
          this.selectedFiles.push(file.file);
        }
      });
    }
  }

  public dragOver(element) {
    this.dragging = true;
    this.dragclass = 'dragged';
  }

  public dragLeave(event) {
    this.dragging = false;
    this.dragclass = '';
  }

  public updatePagingAppointments(paging: any) {
    this.paginationAppointmentMessages = paging;
  }

  public toTitleCase(value: string): string {
    if (!value) return '';

    return value
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  get formattedMessages() {
    if (!this.pagedMessages) return [];

    return this.pagedMessages.map(item => ({
      ...item,
      status: this.toTitleCase(item.status),
      messageJson: item.messageJson
        ? {
            ...item.messageJson,
            status: this.toTitleCase(item.messageJson.status)
          }
        : item.messageJson
    }));
  }
}
export default SendAppointmentMessage;
